/* eslint-disable no-underscore-dangle */
import Popper from 'popper.js';
import { createElement, installComponent } from '../utils/createElement';
import { BREAKPOINTS } from '../utils/breakpoints';
import { COLOR_DARK_1, COLOR_DARK_2, COLOR_PRIMARY, COLOR_DARK_4, COLOR_DARK_5, COLOR_LIGHT_BLUE, COLOR_WHITE, COLOR_LIGHT_GRAY, COLOR_LIGHT_GRAY_2, COLOR_GRAY_900, COLOR_BLUE } from '../utils/colors';
import { closeAllTabs } from '../utils/closeAllTabs';

export default class SideNavLink extends HTMLElement {
  constructor() {
    super();

    this.root = null;
    this.transform = 0;
    this.collapsedHeight = 0;

    this.toggle = this.toggle.bind(this);
    this.addStyleForActiveLink = this.addStyleForActiveLink.bind(this);
    this.changeExpanded = this.changeExpanded.bind(this);
    this.redirectSubLink = this.redirectSubLink.bind(this);
    this.toggleStrategy = 'normal';
    this.popperInstance = null;

    this._expanded = false;

    this._disable = 1;

    this._rootNode = undefined;
    this._symbol = null;
    this._arrowSymbol = null;

    this.activeLinkValue = null;

    this.attachShadow({ mode: 'open' });
  }

  get activeLink() {
    return this.activeLinkValue;
  }

  set activeLink(value) {
    this.activeLinkValue = value;
    this.activeLinkListener(value);
  }

  activeLinkListener = (value) => {};

  registerActiveLinkListener = (f) => {
    this.activeLinkListener = f;
  };

  get link() {
    return this.getAttribute('link');
  }

  get name() {
    return this.getAttribute('name');
  }

  get icon() {
    return this.getAttribute('icon');
  }

  get variation() {
    // should be parent | sub | primary
    return this.getAttribute('variation');
  }

  get type() {
    return this.getAttribute('type');
  }

  get selected() {
    return this.getAttribute('selected');
  }

  get tags() {
    return this.getAttribute('tags');
  }

  get emitEvent() {
    return this.getAttribute('emitEvent') || this.getAttribute('emit-event') || null;
  }

  get iconClasses() {
    return `sb-sidenav-icon icon-${this.icon}`;
  }

  get iconUse() {
    return `#icon-${this.icon}`;
  }

  get rootNode() {
    if (this._rootNode !== undefined) return this._rootNode;
    let node = this.parentNode;
    while (node.parentNode !== null) {
      node = node.parentNode;
    }
    this._rootNode = node;
    return node;
  }

  get iconSymbol() {
    if (this._symbol !== null) return this._symbol;
    // :P awh yaaa
    this._symbol = this.rootNode && this.rootNode.querySelector(this.iconUse);
    return this._symbol;
  }

  get arrowSymbol() {
    if (this._arrowSymbol !== null) return this._arrowSymbol;
    // :P awh yaaa

    const arrowSelector = this.variation === 'parent' ? '#icon-ln-chevron-down' : '#icon-ln-chevron-right';
    this._arrowSymbol = this.rootNode && this.rootNode.querySelector(arrowSelector);
    return this._arrowSymbol;
  }

  get el() {
    return this.parentElement.children[this.name];
  }

  get sub() {
    return this.parentElement.children[`sub${this.name}`];
  }

  get subHeight() {
    return this.sub.firstElementChild.getBoundingClientRect().height;
  }

  connectedCallback() {
    const icon = this.createIconElement();
    const arrow = createElement('div', { class: `sb-sidenav-icon sb-sidenav-icon__arrow sb-sidenav-icon__arrow--${this.variation}` });
    if (this.arrowSymbol) {
      arrow.innerHTML = `
      <svg class="sb-sidenav-icon__sprite" viewBox="${this.arrowSymbol.getAttribute('viewBox')}">
        <g>
          ${this.arrowSymbol.innerHTML}
        </g>
      </svg>`;
    }

    let newBadge;
    if (this.type === 'new') {
      newBadge = createElement('span', { class: 'sb-sidenav-new-badge' }, 'New');
    } else if (this.tags && this.tags.includes('account-switch') && this.tags.includes('header')) {
      newBadge = createElement('span', { class: 'account-switch-primary-badge' }, 'Primary');
    }

    const linkText = this.resolveLinkText();
    const name = createElement('div', { class: 'sb-sidenav-icon__name' }, [linkText, newBadge ?? '']);

    let rootClass = `sb-sidenav-link sb-sidenav-link--${this.variation}`;

    if (this.variation !== 'sub') rootClass += ' sb-sidenav-link--inactive';

    if (this.variation === 'sub' && this.tags && this.tags.includes('account-switch')) {
      if (this.tags.includes('footer')) {
        rootClass += ' account-switch-footer';
      }
      rootClass += ' account-switch';
      if (this.selected) {
        rootClass += ' account-switch-selected';
        const checkmarkIcon = createElement('div', { class: `sb-sidenav-icon__name account-switch` });
        checkmarkIcon.innerHTML = `<svg width="18" height="16" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5.54972 9.15L14.0247 0.675C14.2247 0.475 14.4581 0.375 14.7247 0.375C14.9914 0.375 15.2247 0.475 15.4247 0.675C15.6247 0.875 15.7247 1.1125 15.7247 1.3875C15.7247 1.6625 15.6247 1.9 15.4247 2.1L6.24972 11.3C6.04972 11.5 5.81639 11.6 5.54972 11.6C5.28305 11.6 5.04972 11.5 4.84972 11.3L0.549719 7C0.349719 6.8 0.253885 6.5625 0.262219 6.2875C0.270552 6.0125 0.374719 5.775 0.574719 5.575C0.774719 5.375 1.01222 5.275 1.28722 5.275C1.56222 5.275 1.79972 5.375 1.99972 5.575L5.54972 9.15Z" fill="#2470AF"/>
        </svg>`;
        name.appendChild(checkmarkIcon);
      }
    }

    const elements = this.variation === 'parent' && (this.type !== 'popover' && this.type !== 'account-switch') ? [
      icon,
      name,
      arrow,
    ] : [
      icon,
      name,
    ];

    const div = createElement(
      'div',
      {
        class: `sb-sidenav-link-box
         ${this.variation === 'sub' ? 'sb-sidenav-link-box-sub' : ''}
         ${this.tags && this.tags.includes('account-switch') && this.tags.includes('footer') ? 'account-switch account-switch-footer' : ''}
         ${this.tags && this.tags.includes('account-switch') && this.tags.includes('header') ? 'account-switch account-switch-header' : ''}
         ${!this.iconSymbol ? 'no-icon' : ''}`,
      },
      elements,
    );

    this.root = createElement('a', { class: rootClass, href: this.link, title: this.name, 'data-sb-automation': this.name }, div);

    const triggerEvent = (e) => {
      // stop href
      e.preventDefault();
      // emit event instead
      const clickEvent = new CustomEvent('link-clicked', {
        detail: {
          link: this.link,
          name: this.name,
          variation: this.variation,
        },
        bubbles: true,
        composed: true,
      });

      this.dispatchEvent(clickEvent);
    };

    if (this.emitEvent) {
      this.root.onclick = triggerEvent;
    }

    if (this.variation === 'parent') this.root.addEventListener('click', this.toggle);

    if (this.variation === 'sub' || this.variation === 'primary') this.root.addEventListener('click', this.redirectSubLink);

    const animationSpeed = window.innerWidth <= BREAKPOINTS.md || window.innerWidth >= BREAKPOINTS.lg ? 250 : 30;

    const styles = createElement('style', null, `
      .sb-sidenav-link {
        display: flex;
        align-items: center;
        transition: all ${animationSpeed}ms ease;
        box-sizing: border-box;
        cursor: pointer;
        padding: 0 12px;
        color: white;
        opacity: 1;
        text-decoration: none;
        font-family: proxima-nova, sans-serif;
        z-index: 1;
        animation-fill-mode: forwards;
      }
      
      .account-switch.sb-sidenav-link {
        color: ${COLOR_GRAY_900};
      }

      [title="Activity Log"] {
        background-color: ${COLOR_DARK_4};
        padding: 1.2rem 1rem;
      }

      .sb-sidenav-link-box {
        display: flex;
        align-items: center;
        transition: all ${animationSpeed}ms ease;
        width: 256px;
        box-sizing: border-box;
        cursor: pointer;
        padding: 7px 12px;
        color: white;
        opacity: 1;
        text-decoration: none;
        font-family: proxima-nova, sans-serif;
        z-index: 1;
        animation-fill-mode: forwards;
        border-radius: 5px;
      }

      .account-switch .sb-sidenav-link-box {
        color: ${COLOR_DARK_1};
      }

      .popover.account-switch .sb-sidenav-link-box {
        width: 100%;
        padding: 0 3px;
      }

      .account-switch.account-switch-footer.sb-sidenav-link-box,
      .account-switch.account-switch-selected .sb-sidenav-link-box {
        color: ${COLOR_BLUE};
        font-weight: bold;
      }

      .account-switch.account-switch-footer.sb-sidenav-link {
        background-color: ${COLOR_LIGHT_GRAY};
      }

      .sb-sidenav-link-box-sub {
        padding: unset;
      }

      .popover .sb-sidenav-link-box-sub {
        width: 256px;
        padding: 0 12px;
      }

      .sb-sidenav-link--activate {
        animation: activate 500ms linear;
        animation-fill-mode: forwards;
      }
      .sb-sidenav-link--inactive {
        opacity: 0;
      }
      .sb-sidenav-icon.sb-sidenav-icon__main.account-switch {
        height: 1.8rem;
        margin: 0 3px 0 -3px;
      }
      .account-switch-footer .sb-sidenav-icon.sb-sidenav-icon__main.account-switch {
        height: 1.2rem;
      }
      .sb-sidenav-icon__sprite {
        display: block;
        width: 1.125rem;
        height: 1.125rem;
        transition: all ${animationSpeed}ms ease;
      }
      .sb-sidenav-icon {
        flex-basis: 1.8rem;
        display: block;
        stroke-width: 0;
        stroke: currentColor;
        fill: currentColor;
        transition: all ${animationSpeed}ms ease;
      }
      .sb-sidenav-icon__name {
        flex-basis: 80%;
        display: flex;
        align-items: center;
        white-space: nowrap;
        justify-content: space-between;
      }
      .account-switch .sb-sidenav-icon__name {
        flex-basis: 100%;
      }
      .account-switch .sb-sidenav-icon__name > .sb-sidenav-icon__name {
        justify-content: flex-end
      }
      .sb-sidenav-icon__arrow {
        flex-basis: 10%;
        margin: 0;
        transition: all ${animationSpeed}ms ease;
        opacity: 0;
        display: flex;
        flex-grow: 2;
        justify-content: flex-end;
      }
      .sb-sidenav-icon__arrow--primary, .sb-sidenav-icon__arrow--sub {
        transform: translateX(-10px);
      }
      .sb-sidenav-icon__arrow--parent {
        transform: translateY(-10px);
      }
      .sb-sidenav-link-box:hover > .sb-sidenav-icon__arrow {
        opacity: 0.5;
      }
      .sb-sidenav-link-box:hover > .sb-sidenav-icon__arrow--primary {
        opacity: 0;
      }
      .sb-sidenav-link-box:hover > .sb-sidenav-icon__arrow--sub {
        transform: translateX(0px);
      }
      .sb-sidenav-link-box:hover > .sb-sidenav-icon__arrow--parent {
        transform: translateY(0px);
      }

      .sb-sidenav-link:hover > .sb-sidenav-link-box {
        display: flex;
        align-items: center;
        transition: all ${animationSpeed}ms ease;
        box-sizing: border-box;
        cursor: pointer;
        color: white;
        opacity: 1;
        text-decoration: none;
        font-family: proxima-nova, sans-serif;
        z-index: 1;
        animation-fill-mode: forwards;
        background: ${COLOR_DARK_1};
        border-radius: 5px;
      }

      .account-switch.sb-sidenav-link:hover > .sb-sidenav-link-box {
        color: ${COLOR_DARK_2};
      }

      .account-switch.account-switch-footer.sb-sidenav-link:hover > .sb-sidenav-link-box {
        color: ${COLOR_BLUE};
      }

      .account-switch.account-switch-selected.sb-sidenav-link:hover > .sb-sidenav-link-box,
      .account-switch.account-switch-footer.sb-sidenav-link-box:hover {
        color: ${COLOR_BLUE};
      }

      .sb-sidenav-link--sub:hover > .sb-sidenav-link-box {
        background: unset;
      }

      .sb-sidenav-link--sub:active {
        background: ${COLOR_DARK_1};
      }

      .account-switch.sb-sidenav-link--sub:active {
        background: ${COLOR_LIGHT_BLUE};
      }

      .sb-sidenav-link--sub:hover {
        background: ${COLOR_DARK_1};
      }

      .account-switch.sb-sidenav-link--sub:hover {
        background: ${COLOR_LIGHT_GRAY_2}85;
      }

      .account-switch.account-switch-selected.sb-sidenav-link--sub {
        background:${COLOR_LIGHT_BLUE}85;
      }
      
      .account-switch.account-switch-selected.sb-sidenav-link--sub:hover,
      .account-switch.account-switch-footer.sb-sidenav-link--sub:hover {
        background:${COLOR_LIGHT_BLUE};
      }

      .sb-sidenav-link--sub {
        width: calc(256px - 24px);
        padding: 7px 12px;
      }

      .popover.sb-sidenav-link--sub {
        width: unset;
        border-radius: 5px;
      }


      .sb-sidenav-link--sub--active:not(.sb-sidenav-link--primary) {
        background: ${COLOR_PRIMARY}90;
      }

      .sb-sidenav-link--sub--active.sb-sidenav-link--primary > div {
        background: ${COLOR_PRIMARY}90;
      }

      .sb-sidenav-link--active .sb-sidenav-icon__arrow {
        opacity: 0.5;
        transform: translate(0px, 0px);
      }
      .sb-sidenav-link--active .sb-sidenav-icon__arrow--parent, .sb-sidenav-link--active:hover .sb-sidenav-icon__arrow--parent {
        transform: translate(0px, 0px);
      }
      .sb-sidenav-link--active .sb-sidenav-icon__arrow--parent > .sb-sidenav-icon__sprite,
      .sb-sidenav-link--active:hover .sb-sidenav-icon__arrow--parent > .sb-sidenav-icon__sprite {
        transform: rotate(-180deg);
      }

      .sb-sidenav-link--active .sb-sidenav-link-box {
        border-radius: 6px 6px 0 0;
      }
      .sb-sidenav-link--active:hover .sb-sidenav-link-box {
        border-radius: 6px 6px 0 0;
      }

      .sb-sidenav-link--active.popover .sb-sidenav-link-box {
        background: ${COLOR_PRIMARY}90;
        border-radius: 5px;
      }

      .sb-sidenav-link__branch {
        transition: opacity 750ms;
        list-style: none;
        padding: 0;
        margin: 0;
      }

      .sb-sidenav-new-badge {
        background: ${COLOR_PRIMARY};
        padding: 2px 4px;
        border-radius: 2px;
        margin-left: 4px;
        font-size: 11px;
        line-height: 1;
        font-weight: 500;
      }

      .account-switch-primary-badge{
        color: white;
        background: ${COLOR_GRAY_900};
        padding: 4px;
        border-radius: 2px;
        margin-left: 10px;
        font-size: 11px;
        line-height: 1;
        font-weight: 500;
      }

      .sb-sidenav-link--parent {
        background-color: ${COLOR_DARK_2};
      }

      .sb-sidenav-link--expand .sb-sidenav-link-box {
        background: ${COLOR_DARK_5};
      }

      @keyframes activate {
        0% {
          opacity: 0;
        }
        50% {
          opacity: 0;
        }
        100% {
          opacity: 1;
        }
      }

      @media only screen and (max-width: ${BREAKPOINTS.md}px) {

        .sb-sidenav-icon__arrow--parent {
          opacity: 0.5;
        }

        .sb-sidenav-link {
          padding: 0;
        }

        .sub-links {
          width: fit-content;
        }

        .sb-sidenav-link-box > .sb-sidenav-icon__arrow--parent {
          transform: translateY(0px);
        }

        .sb-sidenav-link-box-sub {
          padding: 7px 12px;
        }

        .sb-sidenav-link-box-sub, .sb-sidenav-link.sb-sidenav-link--sub, .sb-sidenav-link--sub:hover > .sb-sidenav-link-box {
          width: calc(100vw - 40px);
        }

        .sb-sidenav-link-box-sub.account-switch,
        .sb-sidenav-link.sb-sidenav-link--sub.account-switch,
        .sb-sidenav-link--sub.account-switch > .sb-sidenav-link-box {
          width: 100%;
          background-color: white;
        }

        .sb-sidenav-link.account-switch.account-switch-selected,
        .sb-sidenav-link.account-switch.account-switch-selected .sb-sidenav-link-box {
          background-color: ${COLOR_LIGHT_BLUE};
        }
          
        .account-switch.account-switch-footer.sb-sidenav-link .sb-sidenav-link-box {
          background-color: ${COLOR_LIGHT_GRAY};
        }

        .sb-sidenav-link--sub.account-switch > .sb-sidenav-link-box {
          padding: 10px 12px;
        }

        .sb-sidenav-link--parent:hover > .sb-sidenav-link-box, .sb-sidenav-link--parent, .sb-sidenav-link--parent .sb-sidenav-link-box,
        .sb-sidenav-link--primary:hover > .sb-sidenav-link-box, .sb-sidenav-link--primary, .sb-sidenav-link--primary .sb-sidenav-link-box {
          width: 100%;
        }

        .sb-sidenav-link-box {
          padding: 10px 12px;
        }

        .sb-sidenav-link-box-sub:not(.no-icon) {
          padding: 10px 28px;
        }

        .sb-sidenav-link--active:hover > .sb-sidenav-link-box {
          background: ${COLOR_DARK_1};
        }

        .sb-sidenav-link--active > .sb-sidenav-link-box {
          background: ${COLOR_DARK_1};
        }

        .sb-sidenav-icon {
          margin-right: 0;
        }

        [title="Activity Log"] {
          background-color: ${COLOR_DARK_4};
          width: 100vw !important;
          padding: 0;
        }

        @media only screen and (min-height: ${BREAKPOINTS.sm}px) {
          [title="Activity Log"] {
            position: fixed;
            bottom: var(--offset-height);
          }
        }

        .sb-sidenav-icon__name {
          font-size: 1.125rem;
          padding-left: 10px;
        }
      }

      @media only screen and (max-width: ${BREAKPOINTS.lg}px) and (min-width: ${BREAKPOINTS.md}px) {
        .sb-sidenav-link--sub--active.sb-sidenav-link--primary .sb-sidenav-link-box {
          background: ${COLOR_PRIMARY}90;
        }

        .sb-sidenav-link-box {
          width: 100%;
          padding: 10px;
        }

        .popover .sb-sidenav-link-box-sub {
          width: 100%;
          padding: 0 12px;
        }

        .sb-sidenav-link {
          padding: 0;
          font-size: 0.9rem;
          width: 100%;
        }
        .sb-sidenav-link--sub {
          padding: 0.5rem 15px;
          font-size: 0.9rem;
          width: 100%;
        }

        .sb-sidenav-link--sub > .sb-sidenav-icon__arrow, .sb-sidenav-link--sub > .sb-sidenav-icon__arrow > .sb-sidenav-icon__sprite {
          width: 1rem;
          height: 1rem;
        }

        .sb-sidenav-icon {
          width: 1.5rem;
          height: 1.5rem;
          margin-right: 0.5rem;
          display: flex;
          align-items: center;
        }
        
        .sb-sidenav-link--sub > .sb-sidenav-icon__main {
          display: none;
        }
        .sb-sidenav-link--sub > .sb-sidenav-icon__arrow {
          margin: 0;
        }

        .no-icon .sb-sidenav-icon {
          width: 0;
          margin: 0;
          flex-basis: unset;
        }

        .sb-sidenav-icon__sprite {
          margin-left: 2px;
        }

        .sb-sidenav-link--active.popover .sb-sidenav-link-box,
        .sb-sidenav-link--active .sb-sidenav-link-box {
          border-radius: 6px;
          background: background: ${COLOR_PRIMARY}90;
        }

        .sb-sidenav-link--active.sb-sidenav-link {
          padding: 0;
        }

        .sb-sidenav-icon__arrow--parent {
          transform: translateX(0);
          opacity: 0.5;
        }

        .sb-sidenav-link-box {
          padding: 10px;
        }

        .sb-sidenav-link-box-sub, .sb-sidenav-link.sb-sidenav-link--sub, .sb-sidenav-link--sub:hover > .sb-sidenav-link-box {
          width: calc(319px - 40px);
        }

        .sb-sidenav-link.sb-sidenav-link--sub.popover, .sb-sidenav-link.sb-sidenav-link--sub.popover:hover > .sb-sidenav-link-box {
          width: calc(319px - 15px);
        }

        [title="Activity Log"] {
          background-color: ${COLOR_DARK_4};
          width: 330px !important;
        }

        .sb-sidenav-link-box-sub {
          padding: 0px 30px;
        }

        .sb-sidenav-link--active .sb-sidenav-link-box {
          border-radius: 6px 6px 0 0;
        }
        .sb-sidenav-link--active:hover .sb-sidenav-link-box {
          border-radius: 6px 6px 0 0;
        }

        .sb-sidenav-link--active.popover .sb-sidenav-link-box {
          background: ${COLOR_PRIMARY}90;
          border-radius: 5px;
        }
      }
    `);

    this.shadowRoot.append(this.root, styles);

    this.collapsedHeight = this.root.getBoundingClientRect().height;
  }

  createIconElement() {
    const icon = createElement('div', { class: 'sb-sidenav-icon sb-sidenav-icon__main' });
    if (this.iconSymbol) {
      icon.innerHTML = `
      <svg class="sb-sidenav-icon__sprite" viewBox="${this.iconSymbol.getAttribute('viewBox')}">
        <g>
          ${this.iconSymbol.innerHTML}
        </g>
      </svg>`;
    } else {
      if (this.icon === 'sub-account-child') {
        const fillColor = this.selected ? COLOR_BLUE : COLOR_LIGHT_GRAY;
        const strokeColor = this.selected ? COLOR_WHITE : COLOR_GRAY_900;
        icon.innerHTML = `
        <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          ${this.type === 'account-switch' ? '' : `<circle cx="12" cy="12" r="12" fill="${fillColor}"/>`}
          <path d="M7.04199 17.25C6.80137 17.25 6.5954 17.1643 6.4241 16.9929C6.25269 16.8216 6.16699 16.6156 6.16699 16.375V7.625C6.16699 7.38437 6.25269 7.17836 6.4241 7.00696C6.5954 6.83565 6.80137 6.75 7.04199 6.75H10.9795C11.2201 6.75 11.4261 6.83565 11.5975 7.00696C11.7688 7.17836 11.8545 7.38437 11.8545 7.625V9.15625H16.9587C17.1993 9.15625 17.4053 9.2419 17.5767 9.41321C17.748 9.58461 17.8337 9.79063 17.8337 10.0312V16.375C17.8337 16.6156 17.748 16.8216 17.5767 16.9929C17.4053 17.1643 17.1993 17.25 16.9587 17.25H7.04199ZM7.04199 16.375H10.9795V14.8438H7.04199V16.375ZM7.04199 13.9688H10.9795V12.4375H7.04199V13.9688ZM7.04199 11.5625H10.9795V10.0312H7.04199V11.5625ZM7.04199 9.15625H10.9795V7.625H7.04199V9.15625ZM11.8545 16.375H16.9587V10.0312H11.8545V16.375ZM13.4587 12.4375C13.3347 12.4375 13.2308 12.3953 13.147 12.3109C13.0631 12.2266 13.0212 12.1221 13.0212 11.9974C13.0212 11.8727 13.0631 11.7691 13.147 11.6865C13.2308 11.6038 13.3347 11.5625 13.4587 11.5625H14.9899C15.1139 11.5625 15.2178 11.6047 15.3017 11.6891C15.3855 11.7734 15.4274 11.8779 15.4274 12.0026C15.4274 12.1273 15.3855 12.2309 15.3017 12.3135C15.2178 12.3962 15.1139 12.4375 14.9899 12.4375H13.4587ZM13.4587 14.8438C13.3347 14.8438 13.2308 14.8016 13.147 14.7172C13.0631 14.6329 13.0212 14.5284 13.0212 14.4036C13.0212 14.279 13.0631 14.1753 13.147 14.0927C13.2308 14.0101 13.3347 13.9688 13.4587 13.9688H14.9899C15.1139 13.9688 15.2178 14.0109 15.3017 14.0953C15.3855 14.1796 15.4274 14.2841 15.4274 14.4089C15.4274 14.5335 15.3855 14.6372 15.3017 14.7198C15.2178 14.8024 15.1139 14.8438 14.9899 14.8438H13.4587Z" fill="${this.type === 'account-switch' ? COLOR_WHITE : strokeColor}"/>
        </svg>`;
        icon.classList.add('account-switch');
      }

      if (this.icon === 'sub-account-parent') {
        const fillColor = this.selected ? COLOR_BLUE : COLOR_LIGHT_GRAY;
        const strokeColor = this.selected ? COLOR_WHITE : COLOR_GRAY_900;
        icon.innerHTML = `
        <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          ${this.type === 'account-switch' ? '' : `<circle cx="12" cy="12" r="12" fill="${fillColor}"/>`}
          <path d="M7 18C6.725 18 6.48961 17.9021 6.29383 17.7062C6.09794 17.5104 6 17.275 6 17V9.75C6 9.475 6.09794 9.23956 6.29383 9.04367C6.48961 8.84789 6.725 8.75 7 8.75H8.75V7C8.75 6.725 8.84794 6.48956 9.04383 6.29367C9.23961 6.09789 9.475 6 9.75 6H14.25C14.525 6 14.7604 6.09789 14.9563 6.29367C15.1521 6.48956 15.25 6.725 15.25 7V11.5H17C17.275 11.5 17.5104 11.5979 17.7063 11.7937C17.9021 11.9896 18 12.225 18 12.5V17C18 17.275 17.9021 17.5104 17.7063 17.7062C17.5104 17.9021 17.275 18 17 18H12.8833V15.25H11.1167V18H7ZM7 17H8.75V15.25H7V17ZM7 14.25H8.75V12.5H7V14.25ZM7 11.5H8.75V9.75H7V11.5ZM9.75 14.25H11.5V12.5H9.75V14.25ZM9.75 11.5H11.5V9.75H9.75V11.5ZM9.75 8.75H11.5V7H9.75V8.75ZM12.5 14.25H14.25V12.5H12.5V14.25ZM12.5 11.5H14.25V9.75H12.5V11.5ZM12.5 8.75H14.25V7H12.5V8.75ZM15.25 17H17V15.25H15.25V17ZM15.25 14.25H17V12.5H15.25V14.25Z" fill="${this.type === 'account-switch' ? COLOR_WHITE : strokeColor}"/>
        </svg>`;
        icon.classList.add('account-switch');
      }

      if (this.icon === 'account-management') {
        icon.innerHTML = `
        <svg viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 3C9 2.71667 9.09583 2.47917 9.2875 2.2875C9.47917 2.09583 9.71667 2 10 2C10.2833 2 10.5208 2.09583 10.7125 2.2875C10.9042 2.47917 11 2.71667 11 3L11 9.6L16 14.6L16 13C16 12.7167 16.0958 12.4792 16.2875 12.2875C16.4792 12.0958 16.7167 12 17 12C17.2833 12 17.5208 12.0958 17.7125 12.2875C17.9042 12.4792 18 12.7167 18 13L18 17C18 17.2833 17.9042 17.5208 17.7125 17.7125C17.5208 17.9042 17.2833 18 17 18L13 18C12.7167 18 12.4792 17.9042 12.2875 17.7125C12.0958 17.5208 12 17.2833 12 17C12 16.7167 12.0958 16.4792 12.2875 16.2875C12.4792 16.0958 12.7167 16 13 16L14.6 16L9.575 10.975C9.39167 10.7917 9.25 10.5792 9.15 10.3375C9.05 10.0958 9 9.84167 9 9.575L9 3ZM2 13C2 12.7167 2.09583 12.4792 2.2875 12.2875C2.47917 12.0958 2.71667 12 3 12C3.28333 12 3.52083 12.0958 3.7125 12.2875C3.90417 12.4792 4 12.7167 4 13L4 14.6L6.45 12.125C6.65 11.925 6.8875 11.825 7.1625 11.825C7.4375 11.825 7.675 11.925 7.875 12.125C8.075 12.325 8.175 12.5667 8.175 12.85C8.175 13.1333 8.075 13.375 7.875 13.575L5.4 16L7 16C7.28333 16 7.52083 16.0958 7.7125 16.2875C7.90417 16.4792 8 16.7167 8 17C8 17.2833 7.90417 17.5208 7.7125 17.7125C7.52083 17.9042 7.28333 18 7 18L3 18C2.71667 18 2.47917 17.9042 2.2875 17.7125C2.09583 17.5208 2 17.2833 2 17L2 13Z" fill="#2470AF"/>
          <path d="M15 6V3H5V6" stroke="#2470AF" stroke-width="2" stroke-linejoin="round"/>
        </svg>`;
        icon.classList.add('account-switch');
      }
    }
    return icon;
  }

  resolveLinkText() {
    let linkText = this.name;
    if (this.name.length > 22
      && ((this.type === 'account-switch')
        || (this.tags && this.tags.includes('account-switch') && this.tags.includes('header')))) {
      linkText = `${this.name.substring(0, 20)}...`;
    } else if (this.tags && this.tags.includes('account-switch') && this.name.length > 28) {
      linkText = `${this.name.substring(0, 25)}...`;
    }
    return linkText;
  }

  updateStrategy() {
    if ((this.type === 'popover' || this.type === 'account-switch') && window.innerWidth <= BREAKPOINTS.md) {
      this.toggleStrategy = 'full-screen';
    }

    switch (this.toggleStrategy) {
      case 'popover':
        this.togglePopover(this.toggleStrategy);
        break;
      case 'account-switch':
        if (window.innerWidth >= BREAKPOINTS.md) {
          this.togglePopover(this.toggleStrategy);
        } else {
          this.toggleNormal(true);
        }
        break;
      case 'full-screen':
        this.toggleNormal(true);
        break;
      case 'normal':
        this.toggleNormal();
        break;
      default:
        this.toggleNormal();
        break;
    }
  }

  toggle() {
    closeAllTabs(this);
    this.changeExpanded();
  }

  updateActiveLink(link) {
    const url = link || window.location.href;
    this.activeLink = Array.from(this.parentElement?.querySelectorAll('sb-sidenav-link')).find(
      (subLink) => subLink.link && url.toLowerCase().includes(subLink.link.toLowerCase()),
    );
  }

  addStyleForActiveLink() {
    this.shadowRoot.querySelector('a').classList.add('sb-sidenav-link--sub--active');
  }

  redirectSubLink() {
    if (this.variation === 'primary') {
      closeAllTabs();
    }

    if (window.innerWidth <= BREAKPOINTS.md) {
      const header = document.querySelector('sb-sidenav').shadowRoot.querySelector('sb-sidenav-header');
      header.activatorEvent();
    }

    if (this.variation === 'sub' && this.parentElement.parentElement.classList.contains('sub-links-container--expand-popover')) {
      const LinkToClose = this.parentElement.getAttribute('name')?.replace('sub', '');

      this.rootNode.querySelector(`sb-sidenav-link[name='${LinkToClose}']`).toggle();
    }
    this.setSelectedItem();
  }

  setSelectedItem() {
    this.updateActiveLink(this.link);
  }

  changeExpanded() {
    this.updateStrategy();

    this._expanded = !this._expanded;
  }

  toggleNormal(isFullScreen = false) {
    if (!this._expanded) {
      if (isFullScreen) {
        const closeMobileButton = createElement(
          'div',
          { class: 'sb-sidenav-mobile-close' },
          [
            createElement('div'),
            createElement('div'),
          ],
        );

        closeMobileButton.addEventListener('click', this.toggle);

        this.sub.appendChild(closeMobileButton);
        document.querySelector('sb-sidenav').shadowRoot.querySelector('.sb-sidenav__body').scrollTo(0, 0);
        document.querySelector('sb-sidenav').shadowRoot.querySelector('.sb-sidenav__body').style.overflowY = 'hidden';
        document.querySelector('sb-sidenav').shadowRoot.querySelector('.sb-sidenav__body').style.marginBottom = '0';
        document.querySelector('sb-sidenav').shadowRoot.querySelector('sb-sidenav-footer').shadowRoot.querySelector('.sb-sidenav-footer').style.height = '0';
        this.sub.querySelector('.sub-links').classList.remove('sb-sidenav-link--full-screen');
        this.sub.querySelector('.sub-links').classList.add('sb-sidenav-link--full-screen--active');

        const subItems = this.sub.querySelectorAll('sb-sidenav-link');
        subItems.forEach((i) => {
          if (i.getAttribute('tags')?.includes('account-switch')) {
            i.shadowRoot.querySelector('.sb-sidenav-link').classList.add('account-switch');
          }
        });
      } else this.sub.querySelector('.sub-links').style.height = 'unset';

      this.addNormal();
    } else {
      if (isFullScreen) {
        document.querySelector('sb-sidenav').shadowRoot.querySelector('.sb-sidenav__body').style.overflowY = 'auto';
        document.querySelector('sb-sidenav').shadowRoot.querySelector('sb-sidenav-footer').shadowRoot.querySelector('.sb-sidenav-footer').style.height = 'unset';
        this.sub.querySelector('.sub-links').classList.remove('sb-sidenav-link--full-screen--active');
        this.sub.querySelector('.sub-links').classList.add('sb-sidenav-link--full-screen');
      }

      this.removeNormal(isFullScreen);
    }
  }

  translateNormal(transform) {
    let animate = false;
    // eslint-disable-next-line no-restricted-syntax
    for (const link of this.parentElement.children) {
      const r = link.root;
      if (animate && link.querySelector('.sub-links')) {
        const transform = link.previousElementSibling.root.offsetY;
        link.firstElementChild.style.transform = `translateY(${transform}px)`;
      }
      if (animate && r) {
        const currentTransform = r.offsetY || 0;
        const newTransform = currentTransform + transform;
        r.offsetY = newTransform;
        r.style.transform = `translateY(${newTransform}px)`;
      }
      if ((link.classList.contains('sb-sidenav-separator') && !(link.classList.contains('account-switch')))) {
        const currentTransform = 0;
        const newTransform = currentTransform + transform;
        link.offsetY = newTransform;
        const translateValue = Math.sign(transform) === 1 ? newTransform : 0;
        link.style.transform = `translateY(${translateValue}px)`;
      }
      if (link === this.el && (this.el.getAttribute('type') !== 'account-switch')) {
        animate = true;
      }
    }
  }

  addNormal() {
    this.translateNormal(this.subHeight);
    this.sub.classList.remove('sub-links-container--collapse');
    this.sub.classList.add('sub-links-container--expand');
    this.sub.classList.add('sb-sidenav-link--active');
    this.root.classList.add('sb-sidenav-link--expand');
    this.root.classList.add('sb-sidenav-link--active');
  }

  removeNormal() {
    this.translateNormal(-this.subHeight);
    this.sub.classList.remove('sub-links-container--expand');
    this.sub.classList.add('sub-links-container--collapse');
    this.root.classList.remove('sb-sidenav-link--active');
    this.root.classList.remove('sb-sidenav-link--expand');
  }

  togglePopover(toggleStrategy) {
    if (!this._expanded) this.addPopover(toggleStrategy);
    else this.removePopover();
  }

  addPopover(toggleStrategy) {
    this.createPopper();
    const subItems = this.sub.querySelectorAll('sb-sidenav-link');

    subItems.forEach((i) => {
      i.shadowRoot.querySelector('.sb-sidenav-link').classList.add('popover');
      if (toggleStrategy === 'account-switch') {
        i.shadowRoot.querySelector('.sb-sidenav-link').classList.add('account-switch');
      }
    });

    this.sub.classList.remove('sub-links-container--collapse-popover');
    this.sub.classList.add('sub-links-container--expand-popover');
    this.root.classList.add('sb-sidenav-link--active');
    this.root.classList.add('popover');
  }

  createPopper() {
    let preventOverflow = {};

    if (window.innerWidth > BREAKPOINTS.lg) {
      preventOverflow = {
        boundariesElement: 'viewport',
        enabled: true,
      };
    }

    this.popperInstance = new Popper(this.el, this.sub.firstElementChild, {
      placement: 'right-center',
      positionFixed: true,
      modifiers: {
        preventOverflow,
        arrow: {
          element: '.sub-links-popover-arrow',
          enabled: true,
        },
        offset: {
          enabled: true,
          offset: '2',
        },
      },
    });
  }

  removePopover() {
    this.sub.classList.remove('sub-links-container--expand-popover');
    this.sub.classList.add('sub-links-container--collapse-popover');
    this.root.classList.remove('sb-sidenav-link--active');

    const subItems = this.sub.querySelectorAll('sb-sidenav-link');

    subItems.forEach((i) => {
      i.shadowRoot.querySelector('.sb-sidenav-link').classList.remove('popover');
      i.shadowRoot.querySelector('.sb-sidenav-link').classList.remove('account-switch');
    });

    this.root.classList.remove('popover');
  }

  partialDisable() {
    this.sub.classList.remove('sub-links-container--expand-popover');
    this.removePopper();
  }

  partialEnable() {
    if (this._expanded) {
      switch (this.toggleStrategy) {
        case 'account-switch':
          this.addPopover('account-switch');
          break;
        case 'popover':
        default:
          this.addPopover();
          break;
      }
    }
  }

  transitionToPopper() {
    if (!this._expanded) {
      this.sub.classList.remove('sub-links-container--collapse');
      return;
    }

    this.sub.classList.remove('sub-links-container--expand');

    // normal -> popper
    const transform = 0;
    let animate = false;
    // eslint-disable-next-line no-restricted-syntax
    for (const link of this.parentElement.children) {
      const r = link.root;
      if (animate && r) r.style.transform = `translateY(${transform}px)`;
      if (link === this.el) animate = true;
    }

    this.createPopper();
    this.sub.classList.add('sub-links-container--expand-popover');
  }

  transitionToNormal() {
    if (!this._expanded) {
      this.sub.classList.remove('sub-links-container--collapse-popover');
      return;
    }

    this.sub.classList.remove('sub-links-container--expand-popover');

    // popper -> normal
    this.removePopper();
    this.translateNormal(this.subHeight);
    this.sub.classList.add('sub-links-container--expand');
  }

  resetOffset() {
    this.root.offsetY = undefined;
  }

  setupListeners() {
    if (!this.addedEventListener) {
      this.sub.addEventListener('animationend', (e) => {
        if (e.animationName === 'collapse-popover-animation') this.removePopper();
      });
    }
    this.addedEventListener = true;
  }

  removePopper() {
    if (this.popperInstance) {
      this.popperInstance.destroy();
      this.popperInstance = null;
    }
  }
}
installComponent('sb-sidenav-link', SideNavLink);
